module.exports = __webpack_public_path__ + "img/feature_3.892d248d.webp";